var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-button"},[_c('a',{attrs:{"href":_vm.data.url,"target":"_blank","rel":"noopener"}},[_vm._v("\n    "+_vm._s(_vm.data.content)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }